export default function TransformationSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/6e865626dec84e7d4db1e8e38ffc61c4.jpg')] bg-cover bg-center opacity-5"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900">
              Un site qui vous ressemble,<br />
              <span className="text-yellow-600">pensé pour convertir.</span>
            </h2>
            <p className="text-xl text-slate-700 mb-8 leading-relaxed">
              Pas un template. Pas un site générique. Un véritable outil de croissance créé sur mesure pour votre business.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-yellow-600/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl text-yellow-500"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">Design qui reflète votre expertise</h3>
                  <p className="text-slate-600">Chaque élément est pensé pour renforcer votre crédibilité et votre positionnement unique</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-yellow-600/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl text-yellow-500"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">Contenu qui parle à vos clients</h3>
                  <p className="text-slate-600">Messages clairs, arguments percutants, appels à l'action stratégiques</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-yellow-600/20 rounded-lg flex-shrink-0">
                  <i className="ri-check-line text-2xl text-yellow-500"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">Optimisé pour la conversion</h3>
                  <p className="text-slate-600">Chaque page est conçue pour transformer vos visiteurs en prospects qualifiés</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20professional%20business%20website%20design%20mockup%20displayed%20on%20elegant%20laptop%20screen%20showing%20clean%20interface%20with%20golden%20accents%20and%20sophisticated%20layout%20representing%20premium%20web%20development%20services%20with%20minimalist%20aesthetic%20and%20professional%20quality%20in%20bright%20contemporary%20office%20environment&width=800&height=600&seq=transform-img-001&orientation=landscape"
              alt="Site web professionnel sur mesure"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-yellow-600/20 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
